/*
	Define recebemos os tipos de solicitação
*/
export default (state, { result } = {}) => 
	state.swagger.solicitacoes.result = result
	

